import type { WithStyles } from '@material-ui/core';
import { Button, withStyles } from '@material-ui/core';
import { bind } from 'bind-decorator';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ReactCodeInput from 'react-code-input';
import type VideoStore from 'tm3-core/controls/video/store';
import styles from './styles';

interface IProps extends WithStyles<typeof videoIdPromptStyles> {
  videoStore: VideoStore;
}

@inject('videoStore')
@observer
class VideoIdPrompt extends Component<IProps, { code: string }> {
  state = {
    code: ''
  };
  @bind
  onChange(code: string) {
    this.setState({ code });
  }
  render() {
    const {
      classes: { inputWrapper, button, alert, buttonPanel },
      videoStore: { checkAppointment, invalidCode }
    } = this.props;

    return (
      <div className={buttonPanel}>
        <p>
          Please enter your code to join the video. (This is the last 7 digits from any message you
          will have been sent.)
        </p>
        <p>If you do not have your code, please contact us immediately.</p>

        <ReactCodeInput
          type="text"
          fields={7}
          value={this.state.code}
          onChange={this.onChange}
          isValid={this.state.code && this.state.code.length === 7}
          className={inputWrapper}
          inputStyleInvalid={styles.inputStyleInvalid}
        />
        {invalidCode && (
          <div className={alert}>
            The submitted code does not seem to be valid, please try again
          </div>
        )}
        <br />
        <Button
          disabled={!(this.state.code && this.state.code.length === 7)}
          className={button}
          onClick={() => checkAppointment(this.state.code)}
        >
          Submit
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(VideoIdPrompt);
